import { supabaseClient } from './supabase'
import { processRequest } from './request'
import { PhoneInputData } from '@/components/PhoneInput'

export const updateAccountData = ({
  user,
  phone,
  name_last,
  name_first,
}: {
  user: any
  name_first: string
  name_last: string
  phone: PhoneInputData | null
}) => {
  return processRequest(
    supabaseClient.auth.updateUser({
      phone: '', // not using it, it requires Twilio ID and OTP verification.
      data: {
        ...user?.user_metadata,
        phone: phone?.local,
        name_last: name_last,
        name_first: name_first,
        country: phone?.country?.code,
        full_phone: phone?.full_phone,
        country_code: phone?.country?.dial_code
          ? parseInt(phone?.country?.dial_code)
          : null,
      },
    })
  )
}
